import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { Box, fadeIn, LobbyWidget } from '@bonanza-social/moonlight';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

function WelcomeLobbyWidget() {
  const [t] = useTranslation('onboarding');
  const { shouldTransmit, handleTransmit } = useTransmitResolver();

  if (!shouldTransmit) {
    return null;
  }

  return (
    <Box entering={fadeIn}>
      <LobbyWidget
        image="common.Megaphone"
        label={t('widgetLabel')}
        onClick={() => handleTransmit()}
        hasUnread
        showUnreadBadge
      />
    </Box>
  );
}

export default memo(WelcomeLobbyWidget);
